import { useState } from "react";
import { Box } from "@mui/material";
import AssignTaskDialog from "./AssignTaskDialog";
import ManualTaskAssignmentReport from "./ManualTaskAssignmentReport";

export default function ClioMatterInteraction() {
  const [assignOpen, setAssignOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAssigned = () => {
    setAssignOpen(false);
    setRefreshKey((key) => key + 1);
  };

  return (
    <Box sx={{ py: 1 }}>
      <ManualTaskAssignmentReport
        onAssignClick={() => setAssignOpen(true)}
        refreshKey={refreshKey}
      />
      <AssignTaskDialog
        open={assignOpen}
        onClose={() => setAssignOpen(false)}
        onAssigned={handleAssigned}
      />
    </Box>
  );
}
